// router/index.js
import React from "react";
import { Navigate } from "react-router-dom";

type RouteConfig = {
  path: string;
  breadcrumb: string;
  component?: React.LazyExoticComponent<React.ComponentType<any>>;
  element?: React.ReactNode;
};

const routes: RouteConfig[] = [
  {
    path: "/:type?/:subtype?/:category?",
    breadcrumb: "貸款申請",
    component: React.lazy(() => import("../views/financeNEW")),
    // component: React.lazy(() => import("../views/finance/main")),
  },
  // {
  //   path: "/aboutus",
  //   breadcrumb: "關於我們",
  //   component: React.lazy(() => import("../views/finance/about-us")),
  // },
  // {
  //   path: "/intro",
  //   breadcrumb: "歐悅貸介紹",
  //   component: React.lazy(() => import("../views/finance/loan-intro")),
  // },
  // {
  //   path: "/my-loan",
  //   breadcrumb: "繳費與查詢",
  //   component: React.lazy(() => import("../views/finance/my-loan")),
  // },
  // {
  //   path: "/loan/:loanType",
  //   breadcrumb: "學生貸款",
  //   component: React.lazy(() => import("../views/financeNEW/productPage")),
  // },
  // {
  //   path: "/rent/:loanType",
  //   breadcrumb: "企業長租",
  //   component: React.lazy(() => import("../views/finance/loan/apply-intro")),
  // },
  // {
  //   path: "/rent/:loanType/apply",
  //   breadcrumb: "學生貸款申請",
  //   component: React.lazy(() => import("../views/finance/loan/apply-form")),
  // },

  // 表單功能 ----------
  {
    path: "/form-submit",
    breadcrumb: "表單送出",
    component: React.lazy(() => import("../views/finance/formPostSalesforce")),
  },
  {
    path: "/received",
    breadcrumb: "表單回應",
    component: React.lazy(() => import("../views/finance/received")),
  },

  // -------------------------

  // {
  //   path: "/privacy-policy",
  //   breadcrumb: "隱私權保護政策",
  //   component: React.lazy(() => import("../views/privacy")),
  // },
  // {
  //   path: "/terms-use",
  //   breadcrumb: "使用者規範",
  //   component: React.lazy(() => import("../views/terms-use")),
  // },

  // zavi confirmed route leads to route with component ---
  // {
  //   path: "/loan/house-sub",
  //   element: <Navigate to="/loan/mortgage?lead-source=network" replace />,
  //   breadcrumb: "Mortgage",
  // },
  // {
  //   path: "/loan/relief",
  //   element: <Navigate to="/loan/labor-relief?lead-source=network" replace />,
  //   breadcrumb: "Labor Relief",
  // },
  // {
  //   path: "/loan/mobile",
  //   element: <Navigate to="/loan/phone?lead-source=network" replace />,
  //   breadcrumb: "Phone",
  // },
  // {
  //   path: "/loan/rent-car",
  //   element: <Navigate to="/rent/biz-lease?lead-source=network" replace />,
  //   breadcrumb: "Business Lease",
  // },
  // {
  //   path: "/loan/motor",
  //   element: <Navigate to="/loan/two-wheel?lead-source=network" replace />,
  //   breadcrumb: "Two Wheel",
  // },
  // {
  //   path: "/loan/owned-auto",
  //   element: <Navigate to="/loan/used-auto?lead-source=network" replace />,
  //   breadcrumb: "Used Auto",
  // },

  // zavi confirmed route leads to route with component ---end

  {
    path: "/OCR-test",
    breadcrumb: "OCR測試用",
    component: React.lazy(() =>
      import("../components/finance/apply-form/FormBasic"),
    ),
    // component: React.lazy(() => import("../views/finance/main")),
  },
  {
    path: "*",
    breadcrumb: "",
    element: <Navigate to="/" replace />,
  },
];

export default routes;
